import { Box, Grid, Typography, styled } from '@mui/material';
import { LoginForm } from '../containers/login/LoginForm';
import CenteredLogo from '../components/CenteredLogo';
import { colorGrayish, colorSecondary } from '../config/theme';
import CustomCarousel from '../components/CustomCarousel';
import { useEffect, useState } from 'react';
import {
  clearLoginState,
  revertRegisterUser,
  revertValidateUser,
  updateTourGuideFlag,
  getSplashScreens
} from '../redux/reducers/authSlice';
import { useDispatch, useSelector } from 'react-redux';
import { createTitle, mapArrayToTypography } from '../utils/utils';
import SnackBarBox from '../components/SnackBarBox';
import { useNavigate } from 'react-router-dom';
import Loader from '../components/Loader';
import {
  setActiveModule,
  toggleExpandMenu
} from '../redux/reducers/layoutSlice';
import { privateRoute } from '../App';
import { getMenuArray } from '../config/cookie';
import {
  hasDashboardMenuAccess,
  hasDashboardPageDataAccess,
  isAdminRoleType
} from '../utils/navigationMenu';

const CustomGrid = styled(Grid)(({ theme }) => ({
  [theme.breakpoints.up('sm')]: { padding: '0px 0px' },
  [theme.breakpoints.up('md')]: { padding: '0px 60px' }
}));

const CaurosalGrid = styled(Grid)(({ theme }) => ({
  // [theme.breakpoints.up('sm')]: { display: 'none' },
  [theme.breakpoints.down('md')]: { display: 'none' }
}));

export default function Login() {
  // constants
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { modules } = useSelector(state => state.layout);
  const [slides, setSlides] = useState([]);

  const {
    isLoading,
    isLoggedIn,
    isError,
    errorContainer,
    authData,
    isUpdatePasswordLoading,
    isUpdatePasswordSuccess,
    splashScreenData,
    isSplashScreenSuccess
  } = useSelector(state => state.auth);

  useEffect(() => {
    document.title = createTitle('Login');
    dispatch(getSplashScreens());
    dispatch(revertValidateUser());
    dispatch(revertRegisterUser());
  }, []);

  // Transform splash screen data to slides format
  useEffect(() => {
    if (
      isSplashScreenSuccess &&
      splashScreenData &&
      splashScreenData.length > 0
    ) {
      const transformedSlides = splashScreenData.map((screen, index) => ({
        title: screen.title || '',
        image:
          screen.image ||
          `./images/login-images/${index + 1}.${index === 2 ? 'jpeg' : index === 3 ? 'png' : 'JPG'}`,
        alt: `login_img${index + 1}`,
        description: screen.description || ''
      }));
      setSlides(transformedSlides);
    } else {
      // Fallback to default slides if API fails
      setSlides([
        {
          title: '',
          image: './images/login-images/1.JPG',
          alt: 'login_img1',
          description:
            'English room- A collaborative space that provides functional English curriculum, digital aids, books, and skilled personnel to students and teachers in order to improve their English literacy and 21st century skills'
        },
        {
          title: '',
          image: './images/login-images/2.JPG',
          alt: 'login_img2',
          description:
            'English room- A collaborative space that provides functional English curriculum, digital aids, books, and skilled personnel to students and teachers in order to improve their English literacy and 21st century skills'
        },
        {
          title: '',
          image: './images/login-images/5.jpg',
          alt: 'login_img_3',
          description:
            'Teacher Training- Our Training Program helps Government School teachers build themselves, improves their teaching practices and strengthens their subject matter knowledge, which enables them to drive better learning outcomes in their classrooms.'
        },
        {
          title: '',
          image: './images/login-images/6.jpg',
          alt: 'login_img4',
          description:
            'Teacher Training- Our Training Program helps Government School teachers build themselves, improves their teaching practices and strengthens their subject matter knowledge, which enables them to drive better learning outcomes in their classrooms.'
        },
        {
          title: '',
          image: './images/login-images/3.jpeg',
          alt: 'login_img5',
          description:
            'English Room on Wheels- Through this program, we provide support and training to school teachers in diverse teaching techniques along with a customized portable box inclusive of digital teaching resources and books to use in their classroom.'
        },
        {
          title: '',
          image: './images/login-images/4.png',
          alt: 'login_img_6',
          description:
            'English Room on Wheels- Through this program, we provide support and training to school teachers in diverse teaching techniques along with a customized portable box inclusive of digital teaching resources and books to use in their classroom.'
        }
      ]);
    }
  }, [isSplashScreenSuccess, splashScreenData]);

  // Dynamic Redirection

  const applicationRoutes = privateRoute;

  const userHasDashboardAccess = () =>
    isAdminRoleType(authData?.roleType) ||
    hasDashboardMenuAccess(getMenuArray()) ||
    hasDashboardPageDataAccess(authData?.pageData);

  useEffect(() => {
    if (!isLoggedIn) return;
    if (authData?.tourGuideFlag) {
      dispatch(updateTourGuideFlag(authData?.userId));
    }

    if (userHasDashboardAccess()) {
      dispatch(setActiveModule('dashboard'));
      navigate('/dashboard');
      return;
    }

    if (
      modules &&
      authData?.tourGuideFlag &&
      authData?.landingModuleName === 'Resources'
    ) {
      const keys = Object.keys(modules);
      const index = keys.indexOf('Resources');
      dispatch(toggleExpandMenu(index >= 0 ? index : null));
    }

    let landingPage = null;

    if (authData?.landingPageId) {
      landingPage = applicationRoutes.find(
        item => item.menu_name === authData?.landingPageName
      );
    }

    if (!landingPage && authData?.pageData) {
      for (const moduleKey in authData.pageData) {
        const pages = authData.pageData[moduleKey];

        if (Array.isArray(pages) && pages.length > 0) {
          const firstActivePage = pages.find(page => page.status);
          if (firstActivePage) {
            landingPage = applicationRoutes.find(
              route => route.menu_name === firstActivePage.pageName
            );
            if (landingPage) break;
          }
        } else {
          const route = applicationRoutes.find(
            route => route.menu_name === moduleKey
          );
          if (route) {
            landingPage = route;
            break;
          }
        }
      }
    }

    const route = landingPage ?? {
      menu_name: 'default',
      path: '/forbidden'
    };

    dispatch(setActiveModule(route.menu_name));
    navigate(route.path);
  }, [isLoggedIn]);

  useEffect(() => {
    if (!isUpdatePasswordLoading && isUpdatePasswordSuccess) {
      setTimeout(() => {
        dispatch(clearLoginState());
      }, 3000);
    }
  }, [isUpdatePasswordSuccess]);

  return (
    <Grid container sx={{ height: '100vh', bgcolor: 'white' }}>
      {/* <CaurosalGrid
        item
        xs={false}
        sm={false}
        md={6}
        lg={6}
        p={2}
        elevation={6}
        square
      >
        <Box
          bgcolor={colorSecondary}
          display={'flex'}
          justifyContent={'center'}
          height={'100%'}
          textAlign={'center'}
          alignItems={'center'}
          borderRadius={'8px'}
        >
          <CustomCarousel slides={slides} />
        </Box>
      </CaurosalGrid> */}

      <Grid
        item
        xs={false}
        sm={false}
        md={6}
        lg={6}
        p={2}
        elevation={6}
        square
        sx={{
          display: { xs: 'none', md: 'flex' }
        }}
      >
        <Box
          bgcolor={colorSecondary}
          display={'flex'}
          justifyContent={'center'}
          height={'100%'}
          textAlign={'center'}
          alignItems={'center'}
          borderRadius={'8px'}
          p={4}
        >
          <Typography
            variant="h5"
            fontWeight={'bold'}
            color={'#000'}
            sx={{ lineHeight: 1.8 }}
          >
            Hello, we are English experts. Here you will find high-quality
            material to teach and learn functional English. Whether you are a
            teacher, a student, or a curious explorer, we hope you enjoy this
            journey with us.
          </Typography>
        </Box>
      </Grid>

      <CustomGrid
        item
        xs={12}
        sm={12}
        md={6}
        lg={6}
        elevation={6}
        square
        display={'flex'}
        alignItems="center"
        justifyContent={'center'}
      >
        <Box
          sx={{
            my: 4,
            display: 'flex',
            flexDirection: 'column',
            width: 340
          }}
        >
          <Grid container mb={2}>
            <Grid item mr={2} width={80} height={80}>
              <CenteredLogo />
            </Grid>
            <Grid
              item
              alignSelf={'end'}
              display={'flex'}
              flexDirection="column"
            >
              <Typography variant="h4" fontWeight={'700'} color={'#000'}>
                Welcome!
              </Typography>
              <Typography color={colorGrayish}>
                Please login into your account.
              </Typography>
            </Grid>
          </Grid>

          <LoginForm />
        </Box>
      </CustomGrid>

      {!isLoading &&
        isError &&
        errorContainer?.errorMessage !== 'Invalid password entered' && (
          <SnackBarBox
            type="error"
            message={mapArrayToTypography(
              errorContainer?.errorMessage?.split(',')
            )}
          />
        )}
      {isLoading && <Loader text="Validating username and password..." />}
      {!isUpdatePasswordLoading && isUpdatePasswordSuccess && (
        <SnackBarBox
          type="success"
          message={'New password reset successfully.'}
        />
      )}
    </Grid>
  );
}
